<!-- 
CustomerIdEdit.vue
功能：客戶ID異動_ID異動
作者：i9400538 陳博承
完成：2021-09-23
-->
<template>
  <main>
    <tab-header-customer-id />
    <div class="tab-content">
      <div class="tab-pane active show">
        <customer-id-content />
      </div>
    </div>
  </main>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { commonMixin } from "@/mixins/common";

//component
import TabHeaderCustomerId from "@/desktop/components/backend/TabHeaderCustomerId";
import CustomerIdContent from "@/desktop/views/backend/CustomerIdContent";

export default {
  name: "CustomerIdEdit",
  mixins: [commonMixin],
  components: {
    TabHeaderCustomerId,
    CustomerIdContent
  },
  computed: {
    ...mapGetters(["BaseUrl", "UserInfo"])
  },
  methods: {
    ...mapActions(["setPageLock"])
  },
  beforeMount() {
    //檢查使用者是否為通路科/數支科的人
    //檢查使用者是否有後台管理權限
    let divNo = this.UserInfo.divNo;
    let functionId = this.UserInfo.functionId || [];
    if (
      divNo !== "9400400" &&
      divNo !== "9N00200" &&
      !functionId.includes("4")
    ) {
      this.$router.push({ path: "/" });
    }
  }
};
</script>
